<template>
  <input
      :class="classInput"
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
  >
</template>

<script>
export default {
  name: 'inputComp',
  props: {
    classInput: String,
    value: String
  }
}
</script>

<style scoped lang="scss">

.input_orange {
  width: calc(100% - 24px);
  height: 53px;
  object-fit: contain;
  border-radius: 9px;
  border: solid 2px #ff8200;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.input_grey {
  margin: 0;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 10px;
  color: #202020;
  width: calc(100% - 22px);
  height: 32px;
}
</style>
